// extracted by mini-css-extract-plugin
export default {"content":"AccountDetails_content__i4wcE","content__download":"AccountDetails_content__download__i5O39"};